module.exports = __webpack_public_path__ + "static/media/r2-2.79ff4fd7.jpg";